import React, { useEffect, useRef, useState, useMemo } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Typography, Row, Col, Form } from "antd";

//
import log from "../../utils/log";
import c from "../../utils/common";
import moment from "moment-timezone";
import metaData from "../../data/metaData";
import _ from "lodash";
import { showErrMsg } from "../../utils/error";

//
import ShopProfile from "../ShopProfile";
import BrandProfile from "../BrandProfile";
import CompanyProfile from "../CompanyProfile";

const Overview = ({ state = {} }) => {
  const { data, form, onChange } = state;

  const [shopForm] = Form.useForm();

  return (
    <Row justify="start" style={{ width: "100%", margin: "1rem 0 5rem 0" }}>
      <Col span={12}>
        <ShopProfile
          state={{
            data: data,
            form: shopForm,
            onChange: onChange,
          }}
          brand={data?.brand}
          readOnly={true} // Explicitly set to true for read-only mode
        />
      </Col>
    </Row>
  );
};

export default Overview;
